import Handles from "@arcgis/core/core/Handles";

export const highLighthandles:Handles = new Handles()

export const layerViewHighlight=(layerView,features:any[],key:string)=>{
    if (highLighthandles.has(key)) {
        highLighthandles.remove(key);
      }
      highLighthandles.add(layerView.highlight(features), key);

}

export const observerHandles:Handles = new Handles()

export const observerAddToHandles=(handle:any,key:string)=>{
  if (observerHandles.has(key)) {
    observerHandles.remove(key);
  }
  observerHandles.add(handle, key);
  return handle

}